var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"stroke no-fill"},[_c('path',{attrs:{"d":"M20.3125 9.375L12.5 17.5272L4.6875 9.375","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }